import type { Action } from './actions';

export interface ConsumableDef {
  id: string;
  color: string;
  glyph: string;
  action?: Action;
  /** special effects handled by the simulation */
  special?: 'draftExtra';
  maxStack: number;
  /** drop weight */
  weight: number;
}

export const CONSUMABLES: Record<string, ConsumableDef> = {
  potion_life: { id: 'potion_life', color: '#ff5c7a', glyph: '♥', maxStack: 5, weight: 5, action: { type: 'heal', target: 'self', pct: 0.4, visual: 'heal' } },
  elixir_haste: { id: 'elixir_haste', color: '#7fffd4', glyph: '»', maxStack: 5, weight: 3, action: { type: 'buff', target: 'self', status: [{ id: 'haste', duration: 20 }], visual: 'haste' } },
  scroll_choice: { id: 'scroll_choice', color: '#ffe9a8', glyph: '✎', maxStack: 5, weight: 2, special: 'draftExtra' },
  bomb: { id: 'bomb', color: '#ff8c42', glyph: '●', maxStack: 5, weight: 3, action: { type: 'area', at: 'aim', radius: 130, damage: 4, tags: ['fire', 'area'], status: [{ id: 'burn', duration: 3, stacks: 2 }], visual: 'explosion_fire_big', knockback: 200 } },
  ward: { id: 'ward', color: '#c9dcff', glyph: '◈', maxStack: 5, weight: 3, action: { type: 'buff', target: 'self', status: [{ id: 'shield', duration: 8, power: 0.3 }], visual: 'ward' } },
};

export const CONSUMABLE_IDS = Object.keys(CONSUMABLES);
